let stopRefreshCallback = null;

export const setStopRefreshCallback = (callback) => {
  stopRefreshCallback = callback;
};

export const stopTokenRefresh = () => {
  if (stopRefreshCallback) {
    stopRefreshCallback();
  }
};
